import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_PATIENT_MYCHART_USER_ID_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type { PatientMyChartUserIdPayload, PatientMyChartUserIdResult } from '../types/getPatientMyChartUserId.types';

/**
 * Retrieves the patient's MyChart user details using the `myChartUserId`
 * obtained from the admin endpoint.
 *
 * The `myChartUserId` is required to identify the corresponding Epic record.
 * This endpoint returns the patient's `WprId`, indicating that an Epic record
 * exists for the specified MyChart user.
 *
 * @param builder RTK Query endpoint builder.
 * @returns The patient's MyChart user details, including the `WprId`.
 */

export const getPatientMyChartUserId = (builder: BuilderType) =>
  builder.query<PatientMyChartUserIdResult, PatientMyChartUserIdPayload>({
    query: (data) => ({
      data,
      method: 'POST',
      url: GET_PATIENT_MYCHART_USER_ID_URL,
    }),
    transformResponse: (response: GenericApiResponse<PatientMyChartUserIdResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }

      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
